import useSWR from 'swr';

import { PERSONAL_INFORMATION_API_URL } from '../utils/api-urls';
import fetcher from '../utils/fetcher';

const usePersonalInformation = (url = PERSONAL_INFORMATION_API_URL) => {
  const { data, error } = useSWR(url, fetcher);

  return {
    data,
    hasError: error,
    isLoading: !data,
  };
};

export default usePersonalInformation;
